import React from 'react';
import _debounce from 'lodash.debounce';
import { Form } from '@tribeplatform/react-components/Form';
import { T, useI18n } from '@tribeplatform/react-components/i18n';
import { useBlock } from '@tribeplatform/react-slate-kit/hooks';
export const IframeBlockSettings = () => {
    const { $t } = useI18n();
    const { block: { props }, upsertProp, } = useBlock();
    return (React.createElement(Form, { onChange: _debounce(e => {
            upsertProp(e.target.name, e.target.value);
        }, 300), defaultValues: props },
        React.createElement("div", { className: "flex flex-col space-y-5" },
            React.createElement(Form.Input, { name: "title", label: "Title" }),
            React.createElement(Form.Input, { name: "src", label: "iFrame URL", helperText: $t({
                    id: 'Blocks.Iframe.IframUrlHelperText',
                    defaultMessage: 'Please note that not every URL is embeddable in an iFrame.',
                }) }),
            React.createElement(Form.Input, { type: "number", name: "height", min: 60, label: React.createElement(T, { id: "Generics.Height", defaultMessage: "Height" }), helperText: $t({
                    id: 'Blocks.Iframe.IframHeightHelperText',
                    defaultMessage: 'In pixels',
                }) }))));
};
//# sourceMappingURL=Settings.js.map